import React from 'react';
import { Trophy, ArrowUp, ArrowDown, Minus } from 'lucide-react';
import { useSupabaseLeaderboard } from '../../hooks/useSupabaseLeaderboard';
import { formatDistanceToNow } from '../../utils/date';
import './RealtimeLeaderboard.css';

export function RealtimeLeaderboard() {
  const { entries, loading, error } = useSupabaseLeaderboard();
  const [lastUpdate] = React.useState(new Date());

  if (loading) {
    return (
      <div className="bg-gray-900 rounded-xl p-6">
        <div className="flex justify-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-yellow-500"></div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="bg-gray-900 rounded-xl p-6">
        <div className="text-red-400 text-center">{error}</div>
      </div>
    );
  }

  if (!entries.length) {
    return (
      <div className="bg-gray-900 rounded-xl p-6">
        <div className="flex items-center gap-2 mb-6">
          <Trophy className="text-yellow-400 w-6 h-6" />
          <h2 className="text-xl font-bold text-white">Top Champions</h2>
        </div>
        <p className="text-gray-400 text-center">No champions yet. Be the first!</p>
      </div>
    );
  }

  return (
    <div className="bg-gray-900 rounded-xl p-6">
      <div className="flex justify-between items-center mb-6">
        <div className="flex items-center gap-2">
          <Trophy className="text-yellow-400 w-6 h-6" />
          <h2 className="text-xl font-bold text-white">Top Champions</h2>
        </div>
        <div className="text-sm text-gray-400">
          Updated {formatDistanceToNow(lastUpdate)}
        </div>
      </div>

      <div className="space-y-2">
        {entries.slice(0, 10).map((entry) => (
          <div
            key={entry.walletAddress}
            className="bg-gray-800 p-4 rounded-lg flex items-center gap-4"
          >
            <span className="text-gray-400 w-8">#{entry.rank}</span>
            <div className="flex-1">
              <span className="text-white">{entry.username}</span>
            </div>
            <div className="text-yellow-400 font-mono">
              {entry.points.toLocaleString()}
            </div>
            <div className="w-6">
              {entry.rank < (entry.previousRank || entry.rank) ? (
                <ArrowUp className="text-green-400 w-4 h-4" />
              ) : entry.rank > (entry.previousRank || entry.rank) ? (
                <ArrowDown className="text-red-400 w-4 h-4" />
              ) : (
                <Minus className="text-gray-400 w-4 h-4" />
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}